import { useRef } from 'react';
import { apiDownload, saveBlob } from '@/lib/api-client';

export function useElectronicInvoiceRetryKey() {
  const receipt = useRef({ value: '', key: crypto.randomUUID() });
  return (value: unknown) => {
    const next = JSON.stringify(value);
    if (receipt.current.value && receipt.current.value !== next)
      receipt.current.key = crypto.randomUUID();
    receipt.current.value = next;
    return receipt.current.key;
  };
}

export async function downloadElectronicInvoice(path: string, name: string) {
  saveBlob(await apiDownload(path, name));
}
